"use strict";

APP.scenes.TitleScene = function () {

    // Invoke (needed)
    EHDI.aka.Container.call(this);

    // ** Properties

    // ** Parent (This reference)
    var _parent = this;

    // ** Graphics
    var _btnAudio, _btnPlay, _sprBG, _sprGizmo, _sprLogo, _txtPlay, _uiScore;


    // Private Methods

    // ** General Methods

    // ** Handler

    var _handler_btnAudio = function (p_enable) {

        // Set mute to sound manager
        APP.managers.sound.setMute(p_enable);

        // Save to storage
        APP.save.isMuted = p_enable;
        APP.managers.storage.setLocalInfo(APP.config.id, APP.save);

        // Play sfx when enabled
        if (APP.save.isMuted === false) APP.managers.sound.playSFX("button_sfx");
    };

    var _handler_btnPlay = function () {

        // Play button sfx
        APP.managers.sound.playSFX("button_sfx");

        // Change to next scene
        APP.managers.scene.changeScene(new APP.scenes.GameScene(), { alpha: new EHDI.scene.TransitionParameter(0, 1), duration: 0.25 });
    };

    // ** Initialization Methods
    var _initProps = function () {


    };

    var _initGraphics = function () {

        // Initialize sprites
        if (!_sprBG) {

            // Get image according to
            _sprBG = new EHDI.aka.Sprite(EHDI.Assets.images["assets/title/img_title_bg.png"]);

            if (_parent) _parent.addChild(_sprBG);
        }

        if (!_sprGizmo) {

            // Get image according to
            _sprGizmo = new EHDI.aka.Sprite(EHDI.Assets.images["assets/title/img_title_gizmo.png"]);
            _sprGizmo.anchor.set(0.5, 0.5);
            _sprGizmo.position.set(1024, 1200);
            if (_parent) _parent.addChild(_sprGizmo);
        }

        if (!_sprLogo) {

            // Get image according to
            _sprLogo = new EHDI.aka.Sprite(EHDI.Assets.images["assets/title/img_title_logo.png"]);
            _sprLogo.anchor.set(0.5, 0.5);
            _sprLogo.position.set(APP.config.stageWidth * 0.5, -500);

            if (_parent) _parent.addChild(_sprLogo);

        }

        if (!_btnAudio) {

            _btnAudio = new EHDI.displays.ToggleButton(EHDI.Assets.images["assets/ui/btn_audio1.png"],
                EHDI.Assets.images["assets/ui/btn_audio3.png"],
                EHDI.Assets.images["assets/ui/btn_audio2.png"],
                EHDI.Assets.images["assets/ui/btn_audio4.png"],
                APP.managers.sound.getMuted());
            _btnAudio.setOnClickFunction(_handler_btnAudio);
            _btnAudio.position.set(APP.config.stageWidth * 0.1, APP.config.stageHeight * 0.09);

            if (_parent) _parent.addChild(_btnAudio);
        }

        if (!_btnPlay) {

            _btnPlay = new EHDI.displays.Button(EHDI.Assets.images["assets/ui/btn_play.png"],
                EHDI.Assets.images["assets/ui/btn_play2.png"], null, null);
            _btnPlay.setOnClickFunction(_handler_btnPlay);
            _btnPlay.position.set(APP.config.stageWidth * 0.5, APP.config.stageHeight * 0.85);

            if (_parent) _parent.addChild(_btnPlay);

            _btnPlay.scaleX = 0;
            _btnPlay.scaleY = 0;
        }

        if (!_txtPlay) {

            _txtPlay = new EHDI.displays.TextSprite(APP.managers.json.getLocale("BTN_PLAY"));
            _txtPlay.anchor.set(0.75, 0.5);

            if (_btnPlay) _btnPlay.addChild(_txtPlay);
        }

        // if ( !_uiScore ) {

        //     _uiScore = new APP.ui.ScoreUI( APP.ui.ScoreType.HIGHSCORE, APP.SBData.highScore );
        //     _uiScore.position.set( APP.config.stageWidth * 0.723, APP.config.stageHeight * 0.0417)
        //     if ( _parent ) _parent.addChild( _uiScore );
        // }

        if (APP.config.debugEnabled === true) {

            if (!APP.debugUtils) {
                APP.debugUtils = new EHDI.debugUtils.debugUtilsContainer(APP.config.version);
                // APP.managers.scene.addNotification( APP.debugUtils );
            }
        }
    };

    var _initListeners = function () {

    };

    // ** Initialization Methods
    var _killProps = function () {

    };

    var _killGraphics = function () {

        if (_sprBG) {

            if (_sprBG.parent) _sprBG.parent.removeChild(_sprBG);

            _sprBG.destroy({ children: true });
        }
        _sprBG = null;

        if (_sprGizmo) {

            if (_sprGizmo.parent) _sprGizmo.parent.removeChild(_sprGizmo);

            _sprGizmo.destroy({ children: true });
        }
        _sprGizmo = null;

        if (_sprLogo) {

            if (_sprLogo.parent) _sprLogo.parent.removeChild(_sprLogo);

            _sprLogo.destroy({ children: true });
        }
        _sprLogo = null;

        if (_btnAudio) {

            _btnAudio.setOnClickFunction(null);
            if (_btnAudio.parent) _btnAudio.parent.removeChild(_btnAudio);

            _btnAudio.destroy({ children: true });
        }
        _btnAudio = null;

        if (_txtPlay) {

            if (_txtPlay.parent) _txtPlay.parent.removeChild(_txtPlay);

            _txtPlay.destroy({ children: true });
        }
        _txtPlay = null;

        if (_btnPlay) {

            _btnPlay.setOnClickFunction(null);
            if (_btnPlay.parent) _btnPlay.parent.removeChild(_btnPlay);

            _btnPlay.destroy({ children: true });
        }
        _btnPlay = null;

        if (_uiScore) {

            if (_uiScore.parent) _uiScore.parent.removeChild(_uiScore);

            _uiScore.destroy({ children: true });
        }
        _uiScore = null;

    };

    var _killListeners = function () {

    };

    // ** Scene Methods
    this.screenWillAppear = function () {


    };

    this.screenDidAppear = function () {
        if (!APP.managers.sound.bgm) {
            APP.managers.sound.autoResumeToggle(true);
            APP.managers.sound.bgm = APP.managers.sound.playBGM("bgm");
        }

        var tlPhase2 = function () {

            this.tl.kill();
            this.tl = new TimelineMax({ repeat: -1, yoyo: true });
            this.tl.to(_sprGizmo, 0.5, { y: _sprGizmo.y - 10, ease: Power0.easeNone });
            this.tl.play();

        }

        this.tl = new TimelineMax({ repeat: 0 });
        this.tl.to(_sprLogo, 1, { y: APP.config.stageHeight * 0.45, ease: Bounce.easeOut });
        this.tl.to(_sprGizmo, 1, { x: APP.config.stageWidth * 0.3, y: APP.config.stageHeight * 0.45, ease: Back.easeOut });
        this.tl.to(_btnPlay, 0.25, { scaleX: 1, scaleY: 1, ease: Back.easeOut });
        this.tl.add(tlPhase2.bind(this));

    };

    this.screenWillDisappear = function () {

        this.tl.stop();
        this.tl.kill();
    };

    this.screenDidDisappear = function () {

        this.destroy({ children: true });
    };

    // ** Handlers

    // Public Methods

    this.destroy = function () {

        // Kill listeners
        _killListeners();

        // Kill graphics
        _killGraphics();

        // Kill props
        _killProps();

        // Call superclass method
        APP.scenes.TitleScene.prototype.destroy.apply(this, arguments);
    };

    // Call init methods
    _initProps();
    _initGraphics();
    _initListeners();

};
APP.scenes.TitleScene.prototype = Object.create(EHDI.aka.Container.prototype);
APP.scenes.TitleScene.prototype.constructor = APP.scenes.TitleScene;
